import { getTmpDocFromLocalStorage } from "./hooks/use-upload-tmp-document.js";
import { useState } from "./state/state.js";
import { useAgentKeyDocuments } from "./hooks/use-agent-key-documents.js";
import { useChatScroll } from "./hooks/use-chat-scroll.js";
import { useCuratedDocuments } from "./hooks/use-curated-documents.js";
import Layout_default from "./views/Layout.vue.js";
import Settings_default from "./views/Settings/Settings.vue.js";
import { Fragment, createCommentVNode, createElementBlock, createElementVNode, createVNode, defineComponent, onBeforeUnmount, onMounted, openBlock, ref, toDisplayString, unref, useTemplateRef } from "vue";
import { useLazyApiClient } from "@scalar/api-client/modal/use-lazy-api-client";
import { initializeWorkspaceEventHandlers } from "@scalar/api-client/v2/workspace-events";
//#region src/Chat.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { ref: "clientModal" };
var _hoisted_2 = ["role"];
var Chat_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "Chat",
	emits: ["uploadApi"],
	setup(__props) {
		const { chat, prompt, settingsModal, eventBus, workspaceStore, config, mode, addDocument } = useState();
		const clientModalRef = useTemplateRef("clientModal");
		const stopClientEvents = initializeWorkspaceEventHandlers({
			eventBus,
			store: ref(workspaceStore),
			hooks: {}
		});
		const clientLoadingStatus = ref("idle");
		useLazyApiClient({
			eventBus,
			status: clientLoadingStatus,
			load: async () => {
				const { createApiClientModal } = await import("@scalar/api-client/modal");
				return () => {
					if (!clientModalRef.value) return null;
					stopClientEvents();
					return createApiClientModal({
						el: clientModalRef.value,
						options: config,
						eventBus,
						workspaceStore
					});
				};
			}
		});
		onBeforeUnmount(stopClientEvents);
		onMounted(async () => {
			const tmpDoc = getTmpDocFromLocalStorage();
			if (mode === "preview" && tmpDoc) await addDocument({
				namespace: tmpDoc.namespace,
				slug: tmpDoc.slug,
				removable: false,
				tmp: true
			});
		});
		useChatScroll();
		useAgentKeyDocuments();
		useCuratedDocuments();
		async function handleSubmit() {
			await chat.sendMessage({ text: prompt.value });
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [
				createElementVNode("div", _hoisted_1, null, 512),
				clientLoadingStatus.value !== "idle" ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "bg-b-1 text-c-1 fixed right-4 bottom-4 z-[10001] rounded-lg border px-4 py-3 text-sm shadow-lg",
					role: clientLoadingStatus.value === "error" ? "alert" : "status"
				}, toDisplayString(clientLoadingStatus.value === "loading" ? "Loading request editor…" : "Could not load the request editor. Refresh the page and try again."), 9, _hoisted_2)) : createCommentVNode("", true),
				createVNode(Layout_default, {
					onSubmit: handleSubmit,
					onUploadApi: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("uploadApi"))
				}),
				createVNode(Settings_default, { modalState: unref(settingsModal) }, null, 8, ["modalState"])
			], 64);
		};
	}
});
//#endregion
export { Chat_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=Chat.vue.script.js.map